import React from "react";
import { Space, Tabs } from "antd";
import { Typography } from "antd";
import { Controller, useFieldArray } from "react-hook-form";
import { useFormContext } from "./FormProvider";

const { Text } = Typography;

export const FormSection = ({
  sections,
  activeKey,
  onChange,
  onEdit,
  defaulValue = {},
  name = "",
}) => {
  const { control, getValues } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Tabs
            type={onEdit ? "editable-card" : "card"}
            activeKey={activeKey}
            onChange={onChange}
            onEdit={
              onEdit
                ? (targetKey, action) => {
                    if (action === "add") {
                      append(defaulValue);
                    } else {
                      remove(targetKey.split(".")[0]);
                    }
                    onEdit(targetKey, action);
                  }
                : null
            }
            items={sections.map((section) => {
              return {
                key: section.key,
                label:
                  activeKey !== section.key && section.isError ? (
                    <Text type="danger">{section.label}</Text>
                  ) : (
                    section.label
                  ),
                children: (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    {section.component || section.inputs}
                  </Space>
                ),
              };
            })}
          />
        );
      }}
    />
  );
};
